<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: ElementListing.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <tr class="collection-list">
    <td class="p-2">
      <button type="button" v-if="isAdmin && enableAddToElement" class="assets_add-new btn btn-reset btn-sm"
        title="Upload assets" @click.prevent="$emit('openNewAssetModal', data)">
        <i class="icon icon-upload text-main font-26 p-0"></i>
      </button>
      <button type="button" v-if="enableEdition" class="collection-list__edit btn btn-reset btn-sm mb-1" title="Edit"
        @click.prevent="$emit('openEditModal', data)">
        <i class="icon icon-edit text-main"></i>
      </button>
      <button type="button" v-if="enableEdition" class="collection-list__delete btn btn-reset btn-sm my-1" title="Delete"
        @click.prevent="$emit('openDeleteModal', data)">
        <i class="icon icon-delete text-main"></i>
      </button>
    </td>
    <!-- <td>{{ data.name }}</td> -->
    <td v-for="(col, idx) in displayedColumns" :key="idx">
      <template v-if="col === 'License'">
        <a v-if="license.url" :href="license.url" target="_blank">
          {{ license.text }}
        </a>
        <span v-else>{{ license.text }}</span>
      </template>
      <template v-if="col === 'Datalab License'">
        <a v-if="datalabLicense.url" :href="datalabLicense.url" target="_blank">
          {{ datalabLicense.text }}
        </a>
        <span v-else>{{ datalabLicense.text }}</span>
      </template>
      <span v-else-if="col === 'Subpaths'">
        {{ data[catalogueFields[col]].map((subpath) => subpath.subpath).join(', ') }}
      </span>
      <span v-else-if="col === 'Contributor Role'">
        {{ data[catalogueFields[col]].map((contributor) => contributor.role_name).join(', ') }}
      </span>
      <span v-else-if="col === 'Picture'">
        <img class="picture" v-if="data[catalogueFields[col]] != '' && data[catalogueFields[col]] != 'None'"
          :src="data[catalogueFields[col]]" alt="Resource Type Picture" />
      </span>
      <span v-else-if="arrayFields.includes(col)">
        {{ data[catalogueFields[col]].join(', ') }}
      </span>
      <span v-else>{{ data[catalogueFields[col]] }}</span>
    </td>
  </tr>
</template>

<script>
import helpers from '@/lib/helpers'

export default {
  name: 'element_list',
  props: {
    // Collection data
    data: Object,
    // Columns to display
    displayedColumns: Array,
    catalogueFields: Object,
    enableEdition: Boolean,
    enableAddToElement: Boolean,
    arrayFields: Array,
  },
  computed: {
    columnKeys() {
      const keys = {}
      for (const col of this.displayedColumns) {
        keys[col] = true
      }

      return keys
    },
    // Parse License link
    license() {
      return helpers.license(this.data.license)
      //Moved to helpers
    },
    // Parse Datalab License link
    datalabLicense() {
      return helpers.license(this.data['datalab_license'])
      //Moved to helpers
    },
    isAdmin() {
      return this.$store.getters.isAdministrator
    },
  },
  mounted() { },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
img {
  &.picture {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
}
</style>
